import Image from 'next/image'
import Trans from 'next-translate/Trans'
import { Icon } from 'components/Icon'
import { Stack } from 'components/Stack'
import { Text } from 'components/Text'
import { useTranslation } from 'hooks/useTranslation'
import { Animation } from './components/Animation'
import { Content, Flex, Item, List, SubscriptionRoot } from './Subscription.styles'

import freshDogFood from '../../../../../../../public/assets/raw-food-subscription/fresh-dog-food-img.webp'
import { Desktop, Mobile } from 'components/Responsive/Mobile'
import Link from 'next/link'
import { ReactNode } from 'react'

export const Subscription = () => {
  const { t } = useTranslation()

  return (
    <SubscriptionRoot id="raw-food-subscription-2">
      <Flex>
        <div>
          <Image src={freshDogFood} alt={t('raw-food-subscription:subscription.alt')} />

          <Desktop breakpoint="bp2">
            <Animation />
          </Desktop>
        </div>

        <Stack direction="column" gap="5">
          <Content>
            <Stack direction="column" gap="4">
              <Stack direction="column" gap="3">
                <Text as="h2" size="h1" weight="bold">
                  {t('raw-food-subscription:subscription.title')}
                </Text>

                <Text as="p" size="headline" weight="bold">
                  {t('raw-food-subscription:subscription.subtitle')}
                </Text>
              </Stack>

              <Text as="p" size="headline">
                {t('raw-food-subscription:subscription.description')}
              </Text>
            </Stack>
          </Content>

          <List>
            {t('raw-food-subscription:subscription.bullets' as any, undefined, {
              returnObjects: true,
            }).map((_, index) => {
              return (
                <Item key={_}>
                  <Stack>
                    <Icon name="checkbox-circle-line" size="5" color="primary-500" />
                    <Text size="headline">
                      <Trans
                        i18nKey={`raw-food-subscription:subscription.bullets.${index}`}
                        components={{
                          bold: <strong />,
                          a: <LinkText href="/meal-plan" />,
                        }}
                      />
                    </Text>
                  </Stack>
                </Item>
              )
            })}
          </List>
        </Stack>

        <Mobile breakpoint="bp2">
          <Animation />
        </Mobile>
      </Flex>
    </SubscriptionRoot>
  )
}

export const LinkText = ({ children, href }: { href: string; children?: ReactNode }) => {
  return (
    <Link href={href} passHref>
      <Text as="a" size="headline" underline>
        {children}
      </Text>
    </Link>
  )
}
